function isString(value: string) {
  return typeof value === "string";
}

function isNumber(value: number) {
  return typeof value === "number" && !isNaN(value);
}
// Returns false if the object is not a function
function isFunction(value: Function) {
  return typeof value === "function";
}

// A simple check to verify that the value is an integer. Uses `isNumber`
// and a simple modulo check.
function isInteger(value: any) {
  return isNumber(value) && value % 1 === 0;
}

// Checks if the value is a boolean
function isBoolean(value: any) {
  return typeof value === "boolean";
}

// Uses the `Object` function to check if the given argument is an object.
function isObject(obj: any) {
  return obj === Object(obj);
}

// Simply checks if the object is an instance of a date
function isDate(obj: any) {
  return obj instanceof Date;
}

// Returns false if the object is `null` of `undefined`
function isDefined(obj: any) {
  return obj !== null && obj !== undefined;
}

// Checks if the given argument is a promise. Anything with a `then`
// function is considered a promise.
function isPromise(p: any) {
  return !!p && isFunction(p.then);
}

function isDomElement(o: any) {
  if (!o) {
    return false;
  }

  if (!o.querySelectorAll || !o.querySelector) {
    return false;
  }

  if (isObject(document) && o === document) {
    return true;
  }

  // http://stackoverflow.com/a/384380/699304
  /* istanbul ignore else */
  if (typeof HTMLElement === "object") {
    return o instanceof HTMLElement;
  } else {
    return (
      o &&
      typeof o === "object" &&
      o !== null &&
      o.nodeType === 1 &&
      typeof o.nodeName === "string"
    );
  }
}

function isArray(value: any) {
  return {}.toString.call(value) === "[object Array]";
}

// Checks if the object is a hash, which is equivalent to an object that
// is neither an array nor a function.
function isHash(value: any) {
  return isObject(value) && !isArray(value) && !isFunction(value);
}

function contains(obj: any, value: any) {
  if (!isDefined(obj)) {
    return false;
  }
  if (isArray(obj)) {
    return obj.indexOf(value) !== -1;
  }
  return value in obj;
}

function unique(array: any) {
  if (!isArray(array)) {
    return array;
  }
  return array.filter(function(el: any, index: any, array: any) {
    return array.indexOf(el) === index;
  });
}

const Validator = {
  isString,
  isNumber,
  isFunction,
  isInteger,
  isBoolean,
  isObject,
  isDate,
  isDefined,
  isPromise,
  isDomElement,
  isArray,
  isHash,
  contains,
  unique
};

export default Validator;
